<template>
  <div class="terminal-basic-button">
    <button :style="'width:'+width" :class="['btn', color]" @click="onClick">{{buttonText}}</button>
  </div>
</template>

<script>
export default {
  name: "TerminalBasicButton",
  props: {
    isDisabled: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: "unibit-yellow" // ["unibit-grey", "unibit-yellow", "unibit-transparent"]
    },
    buttonText: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: ""
    }
  },

  mounted() {},

  methods: {
    // Event Listener
    onClick() {
      console.log("[terminal-basic-button] emit terminalBasicButtonClicked");
      this.$emit("terminalBasicButtonClicked");
    }
  }
};
</script>

<style scope>
.terminal-basic-button {
  min-width: 1rem;
  height: 2.5rem;
  font-family: Raleway;
}

/* color stylings */
.unibit-yellow {
  opacity: 0.9;
  color: white;
  background: #f5a623;
  font-weight: bold;
  border: 1px solid #f5a623;
  font-size: 0.875rem;
  height: 2rem;
  width: 7.5rem;
}

.unibit-yellow:hover {
  color: white;
  opacity: 1;
}

.unibit-transparent {
  background-color: transparent;
  border: 1px solid #f5a623;
  color: #f5a623;
  font-size: 0.875rem;
  height: 2rem;
  width: 7.5rem;
}

.unibit-transparent:hover {
  background-color: #f5a623;
  color: white;
  font-weight: bold;
}

.unibit-text-btn {
  color: #f5a623;
}
</style>







// WEBPACK FOOTER //
// src/components/base/terminal-basic-button.vue